export default __webpack_public_path__ + "static/media/datenight.67894ced.jpg";